<template>
  <div class="horizon-container">
    <div class="flex-1 w-0 h-100 flex-column ptb-10 plr-20">
      <div class="flex h-30 align-center">
        <div class="bg-ff flex flex-1 h-30 align-center plr-10 border-ra">
          <div class="flex align-center mr-20 cursor" v-for="(item, index) in tab" :key="index"
            @click="switchTab(index + 1)">
            <div class="mr-5" :class="index + 1 === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index + 1 === tabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{ item }}</div>
          </div>
          <div class="flex flex-1 justify-end">
            <div class="flex  align-center border-l-f3f4f7 font-12-30313a cursor" @click="toFiltrate"><img
                src="/static/images/shaixuan.png" class="icon-14 ml-10 mr-5" alt="">筛选</div>
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input type="text" placeholder="输入客户名字/电话/合同号" v-model="keywords" clearable
              @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-46b8b0" @click="searchBtn">搜索</button>
        </div>
      </div>
      <div class="mt-10 flex flex-wrap mb-5">
        <div class="flex align-center mr-5 mb-5" :class="index === Index ? 'btn-24-bg-ff' : 'btn-24-bg-ff'"
          @click="clickBtn(index)" @mouseenter="enter(index)" @mouseleave="leave(index)" v-for="(item, index) in showBtn"
          :key="index" v-show="item.showArr.indexOf(tabIndex - 1) > -1">
          <img :src="index === Index ? item.icon : item.icon" class="icon-14 mr-5" alt="">
          <div>{{ item.name }}</div>
        </div>
        <div class="flex flex-1 justify-end">
          <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" @click="exportExcel">
            <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
            <div>导出Excel</div>
          </div>
        </div>
      </div>
      <div class="hr"></div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0 projectTable">
          <erp-table :is-edit="true" ref="erpTable" :table-footer="tableFooter2" @on-modify="onModifyTime"
            modify-method="on-modify" @change-current-row="changeCurrentRow" @select-change="selectChange"
            :table-data="tableData" @on-manage="onManage" :loading="loading" :column-data="columnData"
            :customs="[{ field: 'customerSettleTime', visible: isTimeVisible1 }, { field: 'projectSettleTime', visible: isTimeVisible2 }]"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
        </Pagination>
      </div>
      <move-vertical :max="560" :min="220" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 300px">
        <div class="flex align-center bg-ff ptb-5 plr-10">
          <div class="flex align-center mr-20 cursor pb-5 relative" :class="{ 'tabActive': index === smallTabIndex }"
            v-for="(item, index) in smallTab" :key="index" @click="switchSmallTab(index)">
            <div class="mr-5" :class="index === smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index === smallTabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{ item }}</div>
          </div>
          <div class="flex font-12-ff5555" v-if="currentRow && currentRow.id"> {{ currentRow.name }} /
            {{ currentRow.detailedAddress }}</div>
          <div class="flex align-center ml-10 mr-5 mb-5 btn-24-bg-46b8b0" @click="onStatistical">
            <img src="/static/images/shangmenkehu-bai.png" class="icon-14 mr-5" alt="">
            <div>统计材料领用</div>
          </div>
        </div>
        <div class="mb-10"></div>
        <div class="overflow-y flex-1 h-0">
          <div class="text-left h-100 flex-column">
            <div class="flex flex-wrap mb-5" v-if="currentRow && currentRow.id && smallTabIndex < 4">
              <div
                v-if="permission.includes('commissionBasic') || permission.includes('customerReceivablesBasic') || permission.includes('projectPaymentBasic') || permission.includes('otherReceivablesBasic')"
                class="flex align-center mr-5 mb-5" :class="smallIndex === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-bg-ff'"
                @mouseenter="enter1(0)" @mouseleave="leave1(0)" @click="clickDetailBtn(0)">
                <img :src="smallIndex === 0 ? '/static/images/money-bai.png' : '/static/images/money.png'"
                  class="icon-14 mr-5" alt="">
                <div>新增</div>
              </div>
              <div
                v-if="permission.includes('commissionBooking') || permission.includes('customerReceivablesBooking') || permission.includes('projectPaymentBooking') || permission.includes('otherReceivablesBooking')"
                class="flex align-center mr-5 mb-5" :class="smallIndex === 1 ? 'btn-24-bg-46b8b0' : 'btn-24-bg-ff'"
                @mouseenter="enter1(1)" @mouseleave="leave1(1)" @click="clickDetailBtn(1)">
                <img :src="smallIndex === 1 ? '/static/images/shangmenkehu-bai.png' : '/static/images/shangmenkehu.png'"
                  class="icon-14 mr-5" alt="">
                <div>记账</div>
              </div>
              <block v-if="deleteBtn">
                <div
                  v-if="permission.includes('commissionBasic') || permission.includes('customerReceivablesBasic') || permission.includes('projectPaymentBasic') || permission.includes('otherReceivablesBasic')"
                  class="flex align-center mr-5 mb-5 btn-24-bg-ff">
                  <img src="/static/images/shanchu1.png" class="icon-12-14 mr-5" alt="">
                  <div>删除</div>
                </div>
              </block>
              <block v-else>
                <div
                  v-if="permission.includes('commissionBasic') || permission.includes('customerReceivablesBasic') || permission.includes('projectPaymentBasic') || permission.includes('otherReceivablesBasic')"
                  class="flex align-center mr-5 mb-5 " :class="smallIndex === 2 ? 'btn-24-bg-ff5555' : 'btn-24-bg-ff'"
                  @mouseenter="enter1(2)" @mouseleave="leave1(2)" @click="clickDetailBtn(2)">
                  <img :src="smallIndex === 2 ? '/static/images/shanchu1-bai.png' : '/static/images/shanchu1.png'"
                    class="icon-12-14 mr-5" alt="">
                  <div>删除</div>
                </div>
              </block>
              <div class="flex flex-1 justify-end">
                <div class="flex align-center mr-5 mb-5 btn-24-bg-ff">
                  <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
                  <div>导出Excel</div>
                </div>
              </div>
            </div>
            <div class="thColor flex-1 h-0" v-if="smallTabIndex < 4">
              <erp-table ref="bottomTable" :table-footer="tableFooter3" @get-Detail="getBillDetail"
                :customs="[{ field: 'operate', visible: operateVisible }, { field: 'operate1', visible: operate1Visible }, { field: 'operate2', visible: operate2Visible }, { field: 'account1', visible: smallTabIndex === 0 || smallTabIndex === 3 }, { field: 'operatorName1', visible: smallTabIndex === 0 || smallTabIndex === 3 }, { field: 'account2', visible: smallTabIndex === 1 }, { field: 'operatorName2', visible: smallTabIndex === 1 }, { field: 'account3', visible: smallTabIndex === 2 }, { field: 'operatorName3', visible: smallTabIndex === 2 }]"
                btn-show-key="status" :table-data="tableDataSmall" :loading="loadingSmall" :column-data="columnDataSmall"
                @to-refund="toRefund"></erp-table>
            </div>
            <div class="thColor flex-1 h-0" v-else>
              <vxe-table border height="100%" :auto-resize="true" :resizable="true" show-overflow show-header-overflow
                size="mini" :show-footer="tableFooter && tableFooter.length > 0" :footer-method="footerMethod"
                :data="tableDataSmall2">
                <vxe-table-column title="单据信息">
                  <vxe-table-column field="order.statusStr" title="单据状态" width="110"></vxe-table-column>
                  <vxe-table-column field="order.createTime" title="编制日期" :formatter="['toDateString', 'yyyy-MM-dd']"
                    width="110"></vxe-table-column>
                  <vxe-table-column field="order.name" title="单据类型" width="140"></vxe-table-column>
                  <vxe-table-column field="order.code" title="单据编号" width="170"></vxe-table-column>
                </vxe-table-column>
                <vxe-table-column title="工程材料">
                  <vxe-table-column field="materialCode" title="材料编号" width="120"></vxe-table-column>
                  <vxe-table-column field="materialName" title="材料名称" width="120"></vxe-table-column>
                  <vxe-table-column field="materialStandard" title="规格" width="120"></vxe-table-column>
                  <vxe-table-column field="materialMode" title="型号" width="120"></vxe-table-column>
                  <vxe-table-column field="quantity" title="数量" width="80"></vxe-table-column>
                  <vxe-table-column field="materialUnit" title="单位" width="80"></vxe-table-column>
                </vxe-table-column>
                <vxe-table-column title="采购支出">
                  <vxe-table-column field="costPrice" title="单价" width="80"></vxe-table-column>
                  <vxe-table-column field="totalCost" title="金额" width="80"></vxe-table-column>
                </vxe-table-column>
                <vxe-table-column title="销售收入">
                  <vxe-table-column field="customerPrice" title="单价" width="80"></vxe-table-column>
                  <vxe-table-column field="totalCustomer" title="金额" width="80"></vxe-table-column>
                  <vxe-table-column field="profit" title="毛利" width="80"></vxe-table-column>
                </vxe-table-column>
                <vxe-table-column title="备注">
                  <vxe-table-column field="order.businessName" title="供应商" width="140"></vxe-table-column>
                </vxe-table-column>
              </vxe-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Filtrate ref="filtrate" :filter-list="filterList" :filtrateVisible="filtrateVisible"></Filtrate>
    <add-detail ref="addDetail" @submit-bill="submitBill"
      :type="smallTabIndex === 0 ? 2 : smallTabIndex === 1 ? 1 : smallTabIndex + 1"
      :customer-id="currentRow.id"></add-detail>
    <el-dialog title="明细" :visible.sync="isDetailShow" width="85%" class="handlePlan">
      <div>
        <div class="bg-f3f4f7 flex text-left plr-20 ptb-10 align-center">
          <div class="flex-1 mr-40">
            <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">收款单号：</span>{{ billDetail.number }}
            </div>
            <div class="font-12-30313a flex align-center" v-if="billDetail.status != 2"><span
                class="font-12-b9b9b9">纸质单号：</span><el-input placeholder="请输入" @change="orderNumber" class=""
                v-model="billDetail.writingNumber"></el-input></div>
            <div class="font-12-30313a flex align-center" v-else><span class="font-12-b9b9b9">纸质单号：</span>{{
              billDetail.writingNumber }}</div>
          </div>
          <div class="flex-1 mr-40">
            <div class="font-12-30313a"><span class="font-12-b9b9b9">操作人员：</span>{{ billDetail.operatorName }}</div>
            <div class="font-12-30313a flex align-center" v-if="billDetail.status == 2"><span
                class="font-12-b9b9b9">账户：</span>{{ billDetail.account }}</div>
            <div class="font-12-30313a flex align-center" v-else><span class="font-12-b9b9b9">{{ type === 2 ? '收款' : type
              === 1 ? '付款' : '提成' }}账户：</span>
              <el-select v-model="billDetail.account" placeholder="请选择" @change="selectAccount">
                <div v-for="(item, index) in optionList" :key="index">
                  <template v-if="item.children">
                    <el-option-group :key="item.id" :label="item.name">
                      <el-option v-for="itemcell in item.children" :key="itemcell.id" :label="itemcell.name"
                        :value="itemcell.id">
                      </el-option>
                    </el-option-group>
                  </template>
                  <template v-else>
                    <div>
                      <el-option :label="item.name" :value="item.id"></el-option>
                    </div>
                  </template>
                </div>
              </el-select>
            </div>
          </div>
          <div class="flex-2">
            <div class="font-12-30313a flex">
              <div class="flex"><span class="font-12-b9b9b9">客户信息：</span>{{ billDetail.customerName }}/{{
                billDetail.customerTelephone }}/{{ billDetail.customerAddress }}
              </div>
              <div class="flex flex-1 justify-end align-center" v-if="billDetail.status === 1"><span
                  class="font-12-b9b9b9">开单时间：</span>
                <el-date-picker v-model="billDetail.createTime" type="date" @change="openOrderTime" format="yyyy.MM.dd ">
                </el-date-picker>
              </div>
              <div class="flex flex-1 justify-end" v-else><span class="font-12-b9b9b9">开单时间：</span>
                {{ billDetail.createTime ? Utils.formatDate(billDetail.createTime) : '-' }}</div>
            </div>
            <div class="flex font-12-30313a flex align-center"><span class="font-12-b9b9b9">单号备注：</span><el-input
                placeholder="请输入" @change="orderMark" class="" v-model="billDetail.description"></el-input></div>
          </div>
        </div>
        <div style="height: 360px">
          <erp-table :is-edit="true" :table-data="billDetail.financeBillItemList" :column-data="tableArray1"
            :table-footer="tableFooter1" @on-modify="onModifyRow" modify-method="on-modify"></erp-table>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-bg-46b8b0 mr-10" @click="toSave">保存</div>
        <div class="btn-30-bg-82b925" @click="toPrint">打印</div>
      </div>
    </el-dialog>
    <el-dialog title="单据打印" :visible.sync="isReportShow" :fullscreen="true" class="flex-column" width="85%">
      <report :classify-id="6" :id="billDetail.id"></report>
    </el-dialog>
    <el-dialog title="导出Excel" :visible.sync="isReportShow1" :fullscreen="true" class="flex-column" width="85%">
      <report :classify-id="6" :id="billDetail.id"></report>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import ErpTable from '../../components/ErpTable'
import AddDetail from './comp/AddDetail'
import Filtrate from '../customer/components/Filtrate'
import XEUtils from 'xe-utils'
import Report from '../../components/Report'
XEUtils.mixin({
  toAllowMaterial (cellValue) {
    return cellValue === 1 ? '允许领料' : cellValue === -1 ? '不允许领料' : ''
  },
  toAccounting (cellValue) {
    return cellValue === 2 ? '已记账' : cellValue === 1 ? '未记账' : ''
  },
  toBillStatus (cellValue) {
    switch (cellValue) {
      case 1:
        return '开单'
      case 2:
        return '供应商备货'
      case 3:
        return '供应商送货'
      case 4:
        return '供应商送货完成'
      case 5:
        return '供货完成'
      default:
        return ''
    }
  }
})
export default {
  name: 'projectDetailedAccount',
  components: { Pagination, MoveHorizon, ErpTable, MoveVertical, Filtrate, AddDetail, Report },
  data () {
    return {
      orderTime: '',
      permission: [],
      operateVisible: false,
      operate1Visible: false,
      operate2Visible: false,
      isTimeVisible1: false,
      isTimeVisible2: false,
      keywords: '',
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      tab: ['在建工程', '客户结账', '工程结账', '工程冻结'],
      tabIndex: 1,
      filterList: {},
      filtrateVisible: false,
      isReportShow: false,
      isReportShow1: false,
      isDetailShow: false,
      loadingSmall: false,
      paymentDialog: false,
      deleteBtn: false,
      showBtn: [
        {
          name: '允许领料',
          icon: '/static/images/yunxu.png',
          iconActive: '/static/images/yunxu-bai.png',
          showArr: [0, 1, 2]
        }, {
          name: '不允许领料',
          icon: '/static/images/buyunxu.png',
          iconActive: '/static/images/buyunxu-bai.png',
          showArr: [0, 1, 2]
        }, {
          name: '客户结账',
          icon: '/static/images/money.png',
          iconActive: '/static/images/money-bai.png',
          showArr: [0, 2]
        }, {
          name: '工程结账',
          icon: '/static/images/money.png',
          iconActive: '/static/images/money-bai.png',
          showArr: [1]
        }, {
          name: '工程冻结',
          icon: '/static/images/bufuhe.png',
          iconActive: '/static/images/bufuhe-bai.png',
          showArr: [0]
        },
        //  {
        //   name: '财务同意转意向',
        //   icon: '/static/images/shangmenyubao.png',
        //   iconActive: '/static/images/shangmenyubao-bai.png',
        //   showArr: [0]
        // }, {
        //   name: '财务同意转设计',
        //   icon: '/static/images/shangmenyubao.png',
        //   iconActive: '/static/images/shangmenyubao-bai.png',
        //   showArr: [0]
        // }
        // {
        //   name: '财务同意开工',
        //   icon: '/static/images/shangmenyubao.png',
        //   iconActive: '/static/images/shangmenyubao-bai.png',
        //   showArr: [0]
        // },
        {
          name: '退回在建',
          icon: '/static/images/shangmenkehu.png',
          iconActive: '/static/images/shangmenkehu-bai.png',
          showArr: [1, 3]
        }
      ],
      Index: -1,
      smallIndex: -1,
      classifyList: [],
      tableFooter1: [
        {
          columns: ['planBill', 'realBill', 'undoBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableArray1: [
        {
          type: 'index',
          title: '序号',
          width: '60'
        }, {
          field: 'fundContent',
          title: '款项名称',
          width: '200'
        },
        {
          field: 'planBill',
          title: '应收',
          width: '100'
        },
        {
          field: 'realBill',
          title: '实收',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'undoBill',
          title: '未收',
          width: '100'
        }, {
          field: 'description',
          title: '说明',
          minWidth: '100',
          editRender: {
            name: 'input'
          }
        }
      ],
      tableFooter3: [
        {
          columns: ['money'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnDataSmall: [
        {
          type: 'selection',
          width: '50'
        }, {
          field: 'operate',
          title: '操作',
          width: '120',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '详情',
            methodName: 'get-Detail',
            type: 'btn'
          }, {
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '退单',
            methodName: 'to-refund',
            type: 'btn',
            showStatus: 2
          }]
        }, {
          field: 'operate1',
          title: '操作',
          width: '70',
          isDefine: true,
          child: [{
            className: 'btn-16-bd-85 btn-hover mr-5',
            title: '详情',
            methodName: 'get-Detail',
            type: 'btn'
          }]
        }, {
          field: 'operate2',
          title: '操作',
          width: '70',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '退单',
            methodName: 'to-refund',
            type: 'btn',
            showStatus: 2
          }]
        }, {
          field: 'status',
          title: '记账',
          width: '60',
          formatter: 'toAccounting'
        }, {
          field: 'accountTime',
          title: '记账日期',
          width: '100',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'number',
          title: '单据号',
          width: '100'
        }, {
          field: 'itemName',
          title: '款项内容',
          width: '160'
        }, {
          field: 'money',
          title: '金额',
          width: '120'
        }, {
          field: 'account1',
          title: '收款账户',
          width: '100'
        }, {
          field: 'operatorName1',
          title: '收款人',
          width: '100'
        }, {
          field: 'account2',
          title: '付款账户',
          width: '100'
        }, {
          field: 'operatorName2',
          title: '付款人',
          width: '100'
        }, {
          field: 'account3',
          title: '提成账户',
          width: '100'
        }, {
          field: 'operatorName3',
          title: '提成人',
          width: '100'
        }, {
          field: 'accounterName',
          title: '记账人',
          width: '100'
        }, {
          field: 'createTime',
          title: '编制日期',
          width: '100',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'writingNumber',
          title: '纸质单号',
          minWidth: '120'
        }
      ],
      tableFooter2: [
        {
          columns: ['customerFinance.designAmount', 'customerFinance.contractAmount', 'customerFinance.settlementAmount',
            'customerFinance.receivedAmount', 'customerFinance.undoReceiveAmount', 'customerFinance.subcontractAmount',
            'customerFinance.paidAmount', 'customerFinance.undoPayAmount', 'customerFinance.auxiliaryAmount',
            'customerFinance.projectAmount', 'customerFinance.softAmount', 'customerFinance.otherAmount',
            'customerFinance.commissionAmount', 'customerFinance.projectPayAmount',
            'customerFinance.projectReceiveAmount', 'customerFinance.projectPayAmount'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
          type: 'selection',
          width: '50'
        }, {
          field: 'operate',
          title: '操作',
          width: '70',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '管理',
            methodName: 'on-manage',
            type: 'btn'
          }]
        }, {
          field: 'businessStatus',
          title: '业务状态',
          width: '120'
        }, {
          field: 'currentProcessName',
          title: '客户状态',
          width: '100'
        }, {
          field: 'financeStatusStr',
          title: '财务状态',
          width: '100'
        },
        // {
        //   field: 'financeStartWork',
        //   title: '财务同意开工',
        //   width: '100',
        //   formatter: 'toAgree'
        // },
        {
          field: 'progressStatus',
          title: '工程进度',
          width: '120'
        }, {
          field: 'customerSettleTime',
          title: '客户结账时间',
          width: '200',
          editType: 'date', // 为日期的编辑
          dateConfig: { // 为日期时必填  用来区分是日期还是日期+时间
            format: 'yyyy-MM-dd',
            type: 'date'
          },
          editRender: {
            name: 'input'
          },
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'projectSettleTime',
          title: '工程结账时间',
          width: '200',
          editType: 'date', // 为日期的编辑
          dateConfig: { // 为日期时必填  用来区分是日期还是日期+时间
            format: 'yyyy-MM-dd',
            type: 'date'
          },
          editRender: {
            name: 'input'
          },
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'customerNumber',
          title: '客户编码',
          width: '160'
        }, {
          field: 'name',
          title: '客户名称',
          width: '100'
        }, {
          field: 'telephone',
          title: '电话号码',
          width: '120'
        }, {
          field: 'detailedAddress',
          title: '详细地址',
          minWidth: '240'
        }, {
          field: 'projectContractNo',
          title: '施工合同号',
          minWidth: '120'
        }, {
          field: 'customerAssign.pmName',
          title: '项目经理',
          minWidth: '80'
        }, {
          field: 'customerAssign.salesmanName',
          title: '业务员',
          minWidth: '80'
        }, {
          field: 'customerAssign.designerName',
          title: '设计师',
          minWidth: '80'
        }, {
          field: 'customerFinance.designAmount',
          title: '设计费',
          minWidth: '100'
        }, {
          field: 'customerFinance.contractAmount',
          title: '合同金额',
          minWidth: '100'
        }, {
          field: 'customerFinance.settlementAmount',
          title: '结算金额',
          minWidth: '100'
        }, {
          field: 'customerFinance.receivedAmount',
          title: '收款金额',
          minWidth: '100'
        }, {
          field: 'customerFinance.undoReceiveAmount',
          title: '未收金额',
          minWidth: '100'
        }, {
          field: 'customerFinance.receiveRate',
          title: '收款比例',
          minWidth: '100'
        }, {
          field: 'customerFinance.subcontractAmount',
          title: '分包金额',
          minWidth: '100'
        }, {
          field: 'customerFinance.paidAmount',
          title: '已付工程款',
          minWidth: '100'
        }, {
          field: 'customerFinance.undoPayAmount',
          title: '未付工程款',
          minWidth: '100'
        }, {
          field: 'customerFinance.payRate',
          title: '付款比例',
          minWidth: '100'
        }, {
          field: 'customerFinance.auxiliaryAmount',
          title: '辅材领用',
          minWidth: '100'
        }, {
          field: 'customerFinance.projectAmount',
          title: '主材领用',
          minWidth: '100'
        }, {
          field: 'customerFinance.softAmount',
          title: '软装领用',
          minWidth: '100'
        }, {
          field: 'customerFinance.otherAmount',
          title: '其他收款',
          minWidth: '100'
        }, {
          field: 'customerFinance.commissionAmount',
          title: '佣金提成',
          minWidth: '100'
        }, {
          field: 'customerFinance.projectReceiveAmount',
          title: '工程收入',
          minWidth: '100'
        }, {
          field: 'customerFinance.projectPayAmount',
          title: '工程支出',
          minWidth: '100'
        }, {
          field: 'customerFinance.projectProfit',
          title: '工程利润',
          minWidth: '100'
        }, {
          field: 'customerFinance.projectProfitRate',
          title: '工程利润率',
          minWidth: '100'
        }],
      loading: false,
      tableData: [],
      tableDataSmall: [],
      tableFooter: [
        {
          columns: ['totalCost', 'totalCustomer', 'profit'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableDataSmall2: [],
      smallTab: ['收款明细', '付款明细', '提成明细', '其他收款明细', '辅材明细', '主材明细', '软装明细'],
      smallTabIndex: 0,
      currentRow: {},
      billDetail: {},
      detailRow: {},
      smallRow: {},
      optionList: []
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.getPermission()
    this.getAccount()
  },
  watch: {
    columnDataSmall (newVal) {
      this.columnDataSmall = newVal
      this.getDetail()
    },
    keywords (val) {
      if (val === '') {
        this.getData()
      }
    }
  },
  methods: {
    getAccount () {
      this.axios.post(`${this.$store.state.API_URL_9010}/account/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data
          list.forEach(item => {
            this.axios.post(`${this.$store.state.API_URL_9010}/account/list`, {
              companyId: this.$store.state.companyId,
              parentId: item.id
            }).then(res => {
              if (res.data.success) {
                if (res.data.data.length > 0) {
                  item.children = res.data.data
                }
              }
            })
          })
          this.optionList = list
        }
      })
    },
    selectAccount (way) {
      console.log(way)
      this.billDetail.account = ''
      this.billDetail.accountId = ''
      for (let i = 0; i < this.optionList.length; i++) {
        if (way === this.optionList[i].id) {
          this.billDetail.account = this.optionList[i].name
          this.billDetail.accountId = this.optionList[i].id
        }
        if (!this.billDetail.accountId && this.optionList[i].children) {
          for (let j = 0; j < this.optionList[i].children.length; j++) {
            if (way === this.optionList[i].children[j].id) {
              this.billDetail.account = this.optionList[i].children[j].name
              this.billDetail.accountId = this.optionList[i].children[j].id
            }
          }
        }
      }
      this.orderAccount()
    },
    onManage (row) {
      this.$router.push({ name: 'CustomerManagement', query: { id: row.id, parent: this.parent } })
    },
    getPermission () {
      let list = {}
      if (this.smallTabIndex === 1) {
        list.parent = 'projectPayment'
        list.parentGroup = 'projectPayment'
      } else if (this.smallTabIndex === 0) {
        list.parent = 'customerReceivables'
        list.parentGroup = 'customerReceivables'
      } else if (this.smallTabIndex === 2) {
        list.parent = 'commission'
        list.parentGroup = 'commission'
      } else if (this.smallTabIndex === 3) {
        list.parent = 'otherReceivables'
        list.parentGroup = 'otherReceivables'
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, list).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    toRefund (row) {
      let that = this
      this.$confirm(`确认将本条数据退单？`, '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row.id
        }
        let url = 'financeBill/refund'
        that.axios.post(url, params).then(res => {
          if (res.data.success) {
            that.$message.success('退单成功')
            that.getDetail()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    onStatistical () {
      if (this.currentRow.id) {
        let that = this
        this.$confirm(`统计材料领用时间可能会过长，确定统计？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.loading = true
          let params = {
            customerId: this.currentRow.id
          }
          that.axios.post('customerFinance/statisticsOrderAmount', params).then(res => {
            if (res.data.success) {
              this.$message({
                message: '统计成功',
                type: 'success',
                offset: 400
              })
              that.getData()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
            that.loading = false
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        this.$message({
          message: '请选择客户',
          type: 'warning',
          offset: 400
        })
      }
    },
    selectChange (checked, row) {
      console.log(checked)
    },
    clickBtn (index) {
      let dataArr = this.$refs.erpTable.getSelectEvent()
      if (!dataArr.length) {
        this.$message({
          message: `请先选择要设置的客户`,
          type: 'warning'
        })
        return
      }
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < dataArr.length; i++) {
        idArr.push(dataArr[i].id)
        nameArr.push(dataArr[i].name)
      }
      this.$confirm(`确认设置以下客户：${nameArr.join('、')}？`, '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          ids: idArr.join(',')
        }
        let refresh = false
        switch (index) {
          case 0:
            params.allowMaterial = 1
            break
          case 1:
            params.allowMaterial = -1
            break
          case 2:
            params.financeStatus = 2
            refresh = true
            break
          case 3:
            params.financeStatus = 3
            refresh = true
            break
          case 4:
            params.financeStatus = 4
            refresh = true
            break
          // case 5:
          //   params.agreeIntention = 1
          //   break
          // case 6:
          //   refresh = true
          //   params.agreeDesignContract = 1
          //   break
          case 5:
            params.financeStartWork = 1
            break
          case 6:
            refresh = true
            params.financeStatus = 1
            break
        }
        that.axios.post('customer/modifyFinanceStatus', params).then(res => {
          if (res.data.success) {
            that.$message.success('设置成功')
            that.getData()
            if (refresh) {
              that.currentRow = {}
              that.tableDataSmall = []
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    toPrint () {
      this.isReportShow = true
    },
    onModifyRow (row, cloumn, colName) { // 修改
      this.detailRow = row
    },
    toSave () {
      let financeBillItem = this.billDetail.financeBillItemList
      for (let i = 0; i < financeBillItem.length; i++) {
        if (this.detailRow.fundContent === financeBillItem[i].fundContent) {
          financeBillItem[i].realBill = this.detailRow.realBill
        }
      }
      this.axios.post('financeBillItem/batchModify', financeBillItem).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功')
          this.isDetailShow = false
          this.getBillDetail(this.smallRow)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    exportExcel () {
      this.isReportShow1 = true
    },
    getBillDetail (row) {
      this.smallRow = row
      this.isDetailShow = true
      let params = {
        id: this.smallRow.id
      }
      this.axios.post('financeBill/getById', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          this.billDetail = res.data.data
          if (this.billDetail.financeBillItemList.length > 0) {
            for (var i = 0; i < this.billDetail.financeBillItemList.length; i++) {
              let str = ''
              if (this.billDetail.status === 2) {
                str = 'realBill'
              }
              this.billDetail.financeBillItemList[i].unEditable = str
            }
          }
          this.orderTime = res.data.data.createTime
        }
      })
    },
    orderAccount () {
      let params = {
        id: this.billDetail.id,
        account: this.billDetail.account,
        accountId: this.billDetail.accountId
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    orderNumber (e) { // 纸质单号
      let params = {
        id: this.smallRow.id,
        writingNumber: e
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    orderMark (e) { // 单据备注
      let params = {
        id: this.smallRow.id,
        description: e
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    openOrderTime (e) {
      let params = {
        id: this.smallRow.id,
        createTime: e
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    submitBill () {
      this.$refs.addDetail.isPaymentShow = false
      this.getPermission()
      this.getDetail()
    },
    clickDetailBtn (index) {
      switch (index) {
        case 0:
          this.$refs.addDetail.isPaymentShow = true
          break
        case 1:
          let dataArr = this.$refs.bottomTable.getSelectEvent()
          if (!dataArr.length) {
            this.$message({
              message: `请先选择要记账的数据`,
              type: 'warning'
            })
          } else {
            let idArr = []
            let that = this
            for (let i = 0; i < dataArr.length; i++) {
              idArr.push(dataArr[i].id)
            }
            this.$confirm(`确认将选中数据记账？`, '提示', {
              confirmButtonText: '是的',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let params = {
                ids: idArr.join(',')
              }
              let url = 'financeBill/accounting'
              that.axios.post(url, params).then(res => {
                if (res.data.success) {
                  that.$message.success('记账成功')
                  that.getDetail()
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'error',
                    offset: 400
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
            })
          }
          break
        case 2:
          let dataArr1 = this.$refs.bottomTable.getSelectEvent()
          if (!dataArr1.length) {
            this.$message({
              message: `请先选择要删除的数据`,
              type: 'warning'
            })
          } else {
            let idArr = []
            let that = this
            let st = []
            for (let i = 0; i < dataArr1.length; i++) {
              if (dataArr1[i].status === 2) {
                st.push(dataArr1[i].id)
                this.$message({
                  type: 'warning',
                  message: `${st.join(',')}已记账不能删除`
                })
                return
              }
              idArr.push(dataArr1[i].id)
            }
            this.$confirm(`确认将选中数据删除？`, '提示', {
              confirmButtonText: '是的',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let params = {
                ids: idArr.join(',')
              }
              let url = 'financeBill/deleteByIds'
              that.axios.post(url, this.qs.stringify(params)).then(res => {
                if (res.data.success) {
                  that.$message.success('删除成功')
                  that.getDetail()
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'error',
                    offset: 400
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
            })
          }
      }
    },
    getDetail () {
      if (!this.currentRow || !this.currentRow.id) {
        return
      }
      this.loadingSmall = true
      let url = ''
      let params = {}
      switch (this.smallTabIndex) {
        case 0:
        case 1:
        case 2:
        case 3:
          url = 'financeBill/list'
          params = {
            customerId: this.currentRow.id,
            type: this.smallTabIndex === 0 ? 2 : this.smallTabIndex === 1 ? 1 : this.smallTabIndex + 1
          }
          this.axios.post(url, params).then(res => {
            this.loadingSmall = false
            if (res.data.success) {
              for (let i = 0; i < res.data.data.length; i++) {
                if ((this.permission.includes('commissionBasic') || this.permission.includes('customerReceivablesBasic') || this.permission.includes('projectPaymentBasic') || this.permission.includes('otherReceivablesBasic')) && (this.permission.includes('commissionBooking') || this.permission.includes('customerReceivablesBooking') || this.permission.includes('projectPaymentBooking') || this.permission.includes('otherReceivablesBooking'))) {
                  this.operateVisible = true
                  this.operate1Visible = false
                  this.operate2Visible = false
                } else if (this.permission.includes('commissionBasic') || this.permission.includes('customerReceivablesBasic') || this.permission.includes('projectPaymentBasic') || this.permission.includes('otherReceivablesBasic')) {
                  this.operate1Visible = true
                  this.operateVisible = false
                  this.operate2Visible = false
                } else if (this.permission.includes('commissionBooking') || this.permission.includes('customerReceivablesBooking') || this.permission.includes('projectPaymentBooking') || this.permission.includes('otherReceivablesBooking')) {
                  this.operate2Visible = true
                  this.operateVisible = false
                  this.operate1Visible = false
                }
              }
              console.log(res.data.data)
              for (let i = 0; i < res.data.data.length; i++) {
                if (res.data.data[i].isRed === 1) {
                  res.data.data[i].money = res.data.data[i].money * -1
                }
                res.data.data[i].account1 = res.data.data[i].account
                res.data.data[i].operatorName1 = res.data.data[i].operatorName
                res.data.data[i].account2 = res.data.data[i].account
                res.data.data[i].operatorName2 = res.data.data[i].operatorName
                res.data.data[i].account3 = res.data.data[i].account
                res.data.data[i].operatorName3 = res.data.data[i].operatorName
              }
              this.tableDataSmall = res.data.data
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
          break
        case 4:
          this.getDetailTableData('auxiliary')
          break
        case 5:
          this.getDetailTableData('project')
          break
        case 6:
          this.getDetailTableData('soft')
          break
      }
    },
    getDetailTableData (accountingType) {
      this.axios.post('orderMaterial/queryDetailList', { accountingType, customerId: this.currentRow.id }).then(res => {
        if (res.data.success) {
          let list = res.data.data
          for (let i = 0; i < list.length; i++) {
            if (list[i].order.type === 4 || list[i].order.type === 5 || list[i].order.type === 6 || list[i].order.type === 12 || list[i].order.type === 13) {
              list[i].quantity = -(list[i].quantity)
              list[i].totalCost = -(list[i].totalCost)
              list[i].totalCustomer = -(list[i].totalCustomer)
              list[i].profit = -(list[i].profit)
            }
          }
          this.tableDataSmall2 = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.getPermission()
      this.getDetail()
    },
    onModifyTime (row) {
      this.axios.post('customer/modify', row).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改成功',
            type: 'success',
            offset: 400
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getData () {
      if (this.tabIndex === 2) {
        this.isTimeVisible1 = true
        this.isTimeVisible2 = false
      }
      if (this.tabIndex === 3) {
        this.isTimeVisible1 = true
        this.isTimeVisible2 = true
      }
      if (this.tabIndex === 1) {
        this.isTimeVisible1 = false
        this.isTimeVisible2 = false
      }
      this.loading = true
      let params = {
        page: this.page,
        limit: this.limit,
        financeStatus: this.tabIndex,
        companyId: this.$store.state.companyId,
        keywords: this.keywords,
        status: 1
      }
      this.axios.post('customer/queryWithFinance', params).then(res => {
        this.loading = false
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    searchBtn () {
      this.page = 1
      this.getData()
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getData()
    },
    switchTab (index) {
      this.tabIndex = index
      this.page = 1
      this.getData()
    },
    toFiltrate () {
      this.$refs.filtrate.filtrateVisible = true
    },
    enter (a) {
      this.Index = a
    },
    leave () {
      this.Index = -1
    },
    enter1 (a) {
      this.smallIndex = a
    },
    leave1 () {
      this.smallIndex = -1
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
      this.getPermission()
      this.getDetail()
    },
    footerMethod ({ columns, data }) {
      let footer = []
      if (this.tableFooter) {
        for (let i = 0; i < this.tableFooter.length; i++) {
          footer.push(
            columns.map((column, columnIndex) => {
              if (columnIndex === 0) {
                return this.tableFooter[i].name
              }
              if (this.tableFooter[i].columns.includes(column.property)) {
                switch (this.tableFooter[i].type) {
                  case 'mean': // 平均
                    return this.$utils.mean(data, column.property).toFixed(2)
                  case 'sum': // 合计
                    return this.$utils.sum(data, column.property).toFixed(2)
                  default:
                    return null
                }
              }
              return null
            })
          )
        }
      }
      return footer
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  overflow: hidden;
}

.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}

.decoration-line-hui {
  width: 4px;
  height: 16px;
  background-color: #e2e2e2;
  border-radius: 4px;
}

.thColor /deep/ .vxe-header--column {
  border: 2px #e2e2e2 !important;
  border-right: dashed 1px #e2e2e2 !important;
  background-color: #46b8b0 !important;
}

.thColor /deep/ .vxe-header--row {
  color: #30313a !important;
}

.thColor /deep/.vxe-table.t--border .vxe-header--column .vxe-cell {
  color: #30313a !important;
}

.thColor /deep/ .col--group {
  border-bottom: 1px solid #e2e2e2 !important;
  background: #b9b9b9 !important;

  .vxe-cell {
    color: #fff !important;
  }
}

.thColor /deep/.vxe-table.t--border .col--group.vxe-header--column .vxe-cell {
  color: #fff !important;
}

.thColor /deep/.vxe-table .vxe-body--row .vxe-body--column {
  padding: 0 !important;
}

.tabActive {
  position: relative;

  &:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    background-color: #46b8b0;
    left: 0;
    bottom: 0;
  }
}

.projectTable /deep/ .vxe-header--row .vxe-cell--checkbox {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/financeManage/projectDetailedAccount.vue